import { useDispatch } from "react-redux"
import HuddleAPI from "../../../api/huddle"
import MetricAPI from "../../../api/metric"
import PnLBudgetAPI from "../../../api/pnlBudget"
import { useResponseHandle } from "../../hooks"

const metricAPI = new MetricAPI()
const huddleAPI = new HuddleAPI()
const pnlBudgetAPI = new PnLBudgetAPI()

export const fetchGroupsHandler = async (params: any) => {
  const { token, dispatch, navigate, loading } = params

  loading(true)
  const response = await metricAPI.getMetricGroupsBoarded(token)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempGroupArr: any = []

      result?.data?.forEach((group: any) => {
        tempGroupArr.push({ ...group, label: group?.group_name })
      })

      dispatch([...tempGroupArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchRegionsHandler = async (params: any) => {
  const { token, dispatch, navigate, group } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricRegionsByGroups(token, [
    group?.group_sk,
  ])

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempRegionArr: any = []

      result?.data?.regions?.forEach((region: any) => {
        tempRegionArr.push({ label: region })
      })

      dispatch([...tempRegionArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchClassesHandler = async (params: any) => {
  const { token, dispatch, navigate, group } = params
  const { loading } = params

  loading(true)
  const response = await pnlBudgetAPI.getPnlBudgetClasses(token, [
    group?.group_sk,
  ])

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempRegionArr: any = []

      result?.data?.forEach((region: any) => {
        tempRegionArr.push({ ...region, label: region.transaction_class })
      })

      dispatch([...tempRegionArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchOfficesHandler = async (params: any) => {
  const { token, dispatch, navigate } = params
  const { group, region } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricPracticesByRegions(
    token,
    [group?.group_sk],
    [region.label],
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempOfficeArr: any = []

      result?.data?.forEach((office: any) => {
        tempOfficeArr.push({ ...office, label: office?.name })
      })

      dispatch([...tempOfficeArr])
      loading(false)
    }
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchHuddleData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchHuddleSummaryData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleSummaryByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleSummaryKeyMetricsData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleSummaryKeyMetricsByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchHuddleActiveOpportunitiesData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleActiveOpportunitiesByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchProviderSummaryData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getProviderSummaryByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleTodayAuditData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleTodayAuditByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleYesterdayAuditData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleYesterdayAuditByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleTomorrowAuditData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleTomorrowAuditByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const updateHuddleHours = async (params: any) => {
  const { token, dispatch, navigate, selectedHuddleOffice } = params
  const { loading, selectedProvider, huddleData, newHours, transactionDate } =
    params

  const payload = {
    practice_sk: selectedHuddleOffice?.practice_sk,
    provider_sk: selectedProvider,
    transaction_date: transactionDate,
    hours: newHours,
  }
  loading(true)
  const response = await huddleAPI.EditHuddleByHours(token, payload)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: true,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch()
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
